module.exports = __webpack_public_path__ + "img/3.7692fe2c.png";